<template>
  <OnboardingLayout
    title="KYC Uploads"
    description="Please upload all required documents."
    @onButtonClick="submitForm"
    imageDescription="Kindly upload a means of identification and your utility bill."
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div class="kycUpload-container">
      <div class="kycUpload">
        <!-- Identity -->
        <div class="row">
          <div class="col-md-7">
            <el-form
              ref="form"
              :rules="{
                identity: [
                  {
                    required: true,
                    message: 'Kindly select your means of identification',
                    trigger: 'blur',
                  },
                  { validator: validateUtilityInput, trigger: 'blur' },
                ],
              }"
              :model="formData"
            >
              <el-form-item label="Means of Identification">
                <el-select
                  v-model="formData.moi"
                  placeholder="Please, select your means of identification"
                >
                  <el-option label="Driving License" value="Driving License" />
                  <el-option
                    label="International Passport"
                    value="International Passport"
                  />
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="col-md-5">
            <el-form>
              <el-form-item label="Upload Document">
                <a-upload
                  :action="uploadUrl"
                  :before-upload="beforeUploadMOI"
                  :on-success="onUploadSuccess"
                  :on-error="onUploadError"
                  accept="image/*, application/pdf"
                >
                  <a-button>
                    <a-icon type="upload" /> Upload Document
                  </a-button>
                </a-upload>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- Expiry Date -->
        <div class="row">
          <div class="col-md-12">
            <el-form>
              <el-form-item label="Select Document Expiry Date">
                <el-date-picker
                  v-model="formData.moi_exp_date"
                  type="date"
                  placeholder="Pick a date"
                  style="width: 92%"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- Utility -->
        <div class="row">
          <div class="col-md-7">
            <el-form
              ref="form"
              :rules="{
                utility: [
                  {
                    required: false,
                    message: 'Kindly select your utility bill',
                    trigger: 'blur',
                  },
                  { validator: validateUtilityInput, trigger: 'blur' },
                ],
              }"
              :model="formData"
            >
              <el-form-item label="Utility Bill" prop="utility">
                <el-select
                  v-model="formData.utility_doc"
                  placeholder="Please, select your utility bill"
                >
                  <el-option label="Waste Bill" value="Waste Bill" />
                  <el-option label="Electricity Bill" value="Nepa Bill" />
                </el-select>
                <p>(Not later than 6 months)</p>
              </el-form-item>
            </el-form>
          </div>
          <div class="col-md-5">
            <el-form>
              <el-form-item label="Upload Document">
                <a-upload
                  :action="uploadUrl"
                  :before-upload="beforeUploadUtility"
                  :on-success="onUploadSuccess"
                  :on-error="onUploadError"
                  accept="image/*, application/pdf"
                >
                  <a-button>
                    <a-icon type="upload" /> Upload Document
                  </a-button>
                </a-upload>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import { ONBOARDING_URL } from "@/utils/http-common.js";
import { Button, Icon, Upload } from "ant-design-vue";
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";

export default {
  name: "KYCUpload",
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!",
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!",
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!",
    },
  },
  components: {
    OnboardingLayout,
    "el-form": Form,
    "el-form-item": FormItem,
    "a-upload": Upload,
    "a-button": Button,
    "a-icon": Icon,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
  },
  data() {
    return {
      showLoading: false,
      canContinue: false,
      nextPageName: "OnboardContractUpload",
      formData: {
        utility_doc: "",
        utility_file: "",
        moi_exp_date: "",
        moi: "",
        moi_file: "",
        customer: localStorage.customerId,
      },
      uploadUrl: `${ONBOARDING_URL}/kycfiles/s3-file-upload`,
    };
  },
  methods: {
    checkCanContinue() {
      const { utility_doc, moi_exp_date } = this.formData;
      if (utility_doc && moi_exp_date) {
        this.canContinue = true;
      } else {
        this.canContinue = false;
      }
    },
    handleContinue() {
      //   this.updateGlobalState();
      this.navTo("OSFinish");
    },
    beforeUploadMOI(file) {
      // Add any custom validation logic here
      const formData = new FormData();
      formData.append("file", file);
      const HTTP = this.$httpUtils.FASTHTTP;

      let image_limiter = 5000;
      let convert_image_size = file.size / 1024;
      if (convert_image_size > image_limiter) {
        this.showErrorMsg({ message: "Uploaded image exceeds 5MB" });
      } else {
        HTTP.post("/kycfiles/s3-file-upload", formData).then((res) => {
          if (res && res.data && res.data.url) {
            this.formData.moi_file = res.data.url;
            return true;
          } else {
            return false;
          }
        });
        this.checkCanContinue();
      }
      //   console.log("Before Upload:", file);
      //   return true; // Return false to prevent uploading
    },

    beforeUploadUtility(file) {
      // Add any custom validation logic here
      const formData = new FormData();
      formData.append("file", file);
      const HTTP = this.$httpUtils.FASTHTTP;

      let image_limiter = 5000;
      let convert_image_size = file.size / 1024;
      if (convert_image_size > image_limiter) {
        this.showErrorMsg({ message: "Uploaded image exceeds 5MB" });
      } else {
        HTTP.post("/kycfiles/s3-file-upload", formData).then((res) => {
          if (res && res.data && res.data.url) {
            this.formData.utility_file = res.data.url;
            this.checkCanContinue();
            return true;
          } else {
            return false;
          }
        });
      }
    },
    onUploadSuccess(response, file) {
      console.log("On Upload Success response", response);
      console.log("On Upload Success file", file);
      this.checkCanContinue();
      // Handle successful upload
      //   this.navTo("OSFinish");
    },
    onUploadError(error, file) {
      // Handle upload error
      console.error("Upload Error:", error, file);
    },
    async updateDBData() {
      let pushedDate = this.formData.moi_exp_date.toISOString();
      let data = {
        utility_doc: this.formData.utility_doc,
        utility_file: this.formData.utility_file,
        moi_exp_date: pushedDate,
        moi: this.formData.moi,
        moi_file: this.formData.moi_file,
        customer: localStorage.customerId,
      };
      const onboardingStateId = localStorage.getItem("onboardingStateId");
      try {
        this.showLoading = true;
        const HTTP = this.$httpUtils.FASTHTTP;
        const res = await HTTP.post(
          `/kycfiles/filesapi-file?onboardingStateId=${onboardingStateId}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
            },
          }
        );
        this.showLoading = false;
        if (res.data) {
          this.showSuccessMsg({ message: "Details Successfully Uploaded!" });
          this.navTo(this.nextPageName);
        }
      } catch (error) {
        this.showLoading = false;
        console.log({ error });
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateDBData();
        } else {
          // Form validation failed
        }
      });
    },
    async updateStatus() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const payloadData = {
        currentPageName: "OnboardContractUpload",
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
        },
      })
        .then(
          (res) => console.log(res)
          // this.$store.commit("saveOnboardingCustomerState", res.data)
        )
        .catch((error) => console.log({ error }));
    },
  },
  async mounted() {
    await this.updateStatus();
    // this.paymentType = this.$store.state.onboardingCustomerState.paymentType;
    // this.generateContract();
  },
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.kycUpload-container {
  width: 100%;
  max-width: 527px;
}

.kycUpload {
  // width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: right;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/kycUpload/Index.vue